const menu_toggle = function () {
        const mobile_menu = document.getElementById("main__menu--mobile");
        if(mobile_menu){
            mobile_menu.classList.toggle("active");
        }
    };

document.addEventListener("DOMContentLoaded", function() {
    const menu_toggle_left = document.getElementById("menu-switch-left");
    const menu_toggle_center = document.getElementById("menu-switch-center");
    if(menu_toggle_left && menu_toggle_center){
        menu_toggle_left.onclick = menu_toggle;
        menu_toggle_center.onclick = menu_toggle;
    }
});